"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetchMiddleware;
const _excluded = ["promise", "type", "data"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function fetchMiddleware(errHandler) {
  return () => {
    return next => action => {
      const {
          promise,
          type,
          data
        } = action,
        rest = _objectWithoutProperties(action, _excluded);
      if (!promise) return next(action);
      const SUCCESS = `${type}_SUCCESS`;
      const REQUEST = `${type}_REQUEST`;
      const FAILURE = `${type}_FAILURE`;
      next(_objectSpread(_objectSpread({}, rest), {}, {
        type: REQUEST
      }));
      return promise.then(res => {
        // If call success
        // This uses some of the logic from fetchWrapper so that backwards compatibility can be maintained
        const successState = res.status >= 200 && res.status < 300 ? SUCCESS : FAILURE;
        if (typeof res.text === 'function') {
          return res.text().then(resText => {
            try {
              // Attempt to parse as JSON
              const resJson = JSON.parse(resText);
              next(_objectSpread(_objectSpread({}, rest), {}, {
                res: resJson,
                resStatus: res.status,
                resDataType: 'object',
                data,
                type: successState
              }));
              return {
                status: true,
                res: resJson,
                resStatus: res.status,
                resDataType: 'object',
                error: {}
              };
            } catch {
              // Or use as a plain string
              next(_objectSpread(_objectSpread({}, rest), {}, {
                res: resText,
                resStatus: res.status,
                resDataType: 'string',
                type: successState
              }));
              return {
                status: true,
                res: resText,
                resStatus: res.status,
                resDataType: 'string',
                error: {}
              };
            }
          })
          // res.text() should never need this.
          .catch(err => console.error(err)); // eslint-disable-line
        }
        // Fallback to original method if res.text() is not a function
        next(_objectSpread(_objectSpread({}, rest), {}, {
          res,
          data,
          type: SUCCESS
        }));
        return {
          status: true,
          res,
          error: {}
        };
      }).catch(error => {
        // Keep current failure logic as is
        next(_objectSpread(_objectSpread({}, rest), {}, {
          error,
          data,
          type: FAILURE
        }));
        if (errHandler) {
          errHandler(error);
        }
        return {
          status: false,
          res: {},
          error
        };
      });
    };
  };
}